import { DataGrid } from '@mui/x-data-grid';
import CustomLoading from '../../shared/CustomLoading';

const AccountManagementTable = () => {
	const columns = [
		{
			field: 'type',
			headerName: 'Type',
			flex: 1,
			valueFormatter: value => {
				if (!value) return '';
				return value;
			},
		},
		{
			field: 'account',
			headerName: 'Account',
			flex: 1,
			valueFormatter: value => {
				if (!value) return '';
				return value;
			},
		},
		{
			field: 'npiNumber',
			headerName: 'NPI Number',
			flex: 1,
			valueFormatter: value => {
				if (!value) return '';
				return value;
			},
		},
	];

	// Hard-coded data
	const rows = [
		{
			id: 1,
			type: 'Type 1',
			account: 'Nexus ChiroPractitioner',
			npiNumber: '000000001',
		},
		{
			id: 2,
			type: 'Type 2',
			account: 'Nexus Chiro CA Clinic',
			npiNumber: 'No information found',
		},
	];

	return (
		<DataGrid
			autoHeight
			disableColumnMenu
			disableColumnFilter
			disableColumnResize
			disableColumnSelector
			disableColumnSorting
			disableDensitySelector
			disableMultipleRowSelection
			hideFooter
			getRowId={row => row.id}
			rowHeight={58}
			columns={columns}
			rows={rows}
			loading={false}
			filterMode='server'
			initialState={{
				columns: { columnVisibilityModel: { id: false } },
			}}
			slots={{
				loadingOverlay: CustomLoading,
			}}
			slotProps={{
				toolbar: {
					showQuickFilter: rows.length > 0,
					quickFilterProps: { debounceMs: 1000 },
				},
			}}
			sx={{
				'&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
					outline: 'none',
				},
			}}
		/>
	);
};

export default AccountManagementTable;
